import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import Home from './../pages/home/Home';
import Ofertas from './../pages/ofertas/Ofertas';
import Sobre from './../pages/sobre/Sobre';
import Catalogos from './../pages/catalogos/Catalogos';
import Duvidas from './../pages/duvidas/Duvidas';
import FaleConosco from './../pages/faleConosco/FaleConosco';
import Cadastro from './../pages/cadastro/Cadastro';
import EsqueceuSenha from './../pages/esqueceuSenha/EsqueceuSenha';
import Painel from './../pages/painel/Painel';
import AreaRestrita from './../pages/areaRestrita/AreaRestrita';
import PrivateRoute from './PrivateRoute';


const Routes = props => {


    return (

        <Switch>
            <Route exact path='/' component={Home}></Route>
            <Route path='/ofertas' component={Ofertas}></Route>
            <Route path='/sobre' component={Sobre}></Route>
            <Route path='/catalogos' component={Catalogos}></Route>
            <Route path='/duvidas' component={Duvidas}></Route>
            <Route path='/faleconosco' component={FaleConosco}></Route>
            <Route path='/cadastro' component={Cadastro}></Route>
            <Route path='/esqueceu-senha' component={EsqueceuSenha}></Route>
            <Route path='/restrita' component={AreaRestrita}></Route>
            <PrivateRoute exact path='/painel' component={Painel}></PrivateRoute>
            <PrivateRoute path='/painel/:modulo/:acao/:id' component={Painel}></PrivateRoute>
            <PrivateRoute path='/painel/:modulo/:acao' component={Painel}></PrivateRoute>
            <PrivateRoute path='/painel/:modulo' component={Painel}></PrivateRoute>
            <Redirect from='*' to='/'></Redirect>
        </Switch>

    )
};

export default Routes;